import { machines, sess } from './state.js';
import { openBatModal } from './batteri.js';
import { MASKINE_FELTER, loadMachines } from './maskiner.js';
import { closeModal, toast } from './ui.js';
import { sb } from '../lib/supabase.js';

// ── BILLEDE UPLOAD MED BESKÆRING ─────────────────────
export let cropMachineId = null, cropImgNaturalW = 0, cropImgNaturalH = 0;
export let cropOffX = 0, cropOffY = 0, cropScale = 1;
export let cropDrag = false, cropStartX = 0, cropStartY = 0, cropStartOX = 0, cropStartOY = 0;

export function uploadMachineImage(event, machineId) {
  const file = event.target.files[0];
  if (!file) return;
  cropMachineId = machineId;
  const reader = new FileReader();
  reader.onload = (e) => {
    const img = document.getElementById('cropImg');
    img.onload = () => {
      cropImgNaturalW = img.naturalWidth;
      cropImgNaturalH = img.naturalHeight;
      cropScale = 1;
      cropOffX = 0; cropOffY = 0;
      document.getElementById('cropZoom').value = 1;
      updateCrop();
      document.getElementById('cropModal').classList.add('open');
    };
    img.src = e.target.result;
  };
  reader.readAsDataURL(file);
}

export function updateCrop() {
  cropScale = parseFloat(document.getElementById('cropZoom').value);
  const wrap = document.getElementById('cropWrap');
  const wSize = wrap.offsetWidth;
  const img = document.getElementById('cropImg');
  // Fit billede inden for wrap ved scale=1
  const fitScale = wSize / Math.min(cropImgNaturalW, cropImgNaturalH);
  const dispW = cropImgNaturalW * fitScale * cropScale;
  const dispH = cropImgNaturalH * fitScale * cropScale;
  // Klamp offset så billedet dækker wrap
  cropOffX = Math.min(0, Math.max(wSize - dispW, cropOffX));
  cropOffY = Math.min(0, Math.max(wSize - dispH, cropOffY));
  img.style.width  = dispW + 'px';
  img.style.height = dispH + 'px';
  img.style.left   = cropOffX + 'px';
  img.style.top    = cropOffY + 'px';
}

// Touch og mouse drag
export const cw = () => document.getElementById('cropWrap');
export function cropPointerDown(e) {
  cropDrag = true;
  const pt = e.touches ? e.touches[0] : e;
  cropStartX = pt.clientX; cropStartY = pt.clientY;
  cropStartOX = cropOffX; cropStartOY = cropOffY;
  cw().style.cursor = 'grabbing';
}
export function cropPointerMove(e) {
  if (!cropDrag) return;
  e.preventDefault();
  const pt = e.touches ? e.touches[0] : e;
  cropOffX = cropStartOX + (pt.clientX - cropStartX);
  cropOffY = cropStartOY + (pt.clientY - cropStartY);
  updateCrop();
}
export function cropPointerUp() { cropDrag = false; cw().style.cursor = 'grab'; }

document.addEventListener('DOMContentLoaded', () => {
  const w = document.getElementById('cropWrap');
  w.addEventListener('mousedown',  cropPointerDown);
  w.addEventListener('mousemove',  cropPointerMove);
  w.addEventListener('mouseup',    cropPointerUp);
  w.addEventListener('touchstart', cropPointerDown, { passive: false });
  w.addEventListener('touchmove',  cropPointerMove, { passive: false });
  w.addEventListener('touchend',   cropPointerUp);
});

export async function confirmCrop() {
  const wrap = document.getElementById('cropWrap');
  const img  = document.getElementById('cropImg');
  const wSize = wrap.offsetWidth;
  // Tegn det synlige udsnit på canvas
  const canvas = document.createElement('canvas');
  const out = 600;
  canvas.width = out; canvas.height = out;
  const ctx = canvas.getContext('2d');
  const scaleToNatural = cropImgNaturalW / parseFloat(img.style.width);
  const sx = -cropOffX * scaleToNatural;
  const sy = -cropOffY * scaleToNatural;
  const sw = wSize * scaleToNatural;
  ctx.drawImage(img, sx, sy, sw, sw, 0, 0, out, out);

  closeModal('cropModal');
  toast('📤 Uploader billede…');

  try {
    // Konverter canvas til blob
    const blob = await new Promise(res => canvas.toBlob(res, 'image/jpeg', 0.85));
    const filePath = `machine-images/${cropMachineId}.jpg`;

    // Upload direkte til Supabase Storage
    const { error: upErr } = await sb.storage
      .from('machine-images')
      .upload(filePath, blob, { contentType: 'image/jpeg', upsert: true });

    if (upErr) { toast('❌ ' + upErr.message); return; }

    // Hent public URL
    const { data: urlData } = sb.storage.from('machine-images').getPublicUrl(filePath);
    const publicUrl = urlData.publicUrl + '?t=' + Date.now();

    // Gem URL i Supabase profiles
    await sb.from('machines').update({ custom_image_url: publicUrl }).eq('id', cropMachineId);

    // Opdater billede-banner straks
    const mcEl = document.getElementById(`mc-${cropMachineId}`);
    if (mcEl) {
      const existingImg = mcEl.querySelector('.mc-img');
      if (existingImg) {
        existingImg.src = publicUrl;
      } else {
        // Erstat placeholder med rigtigt billede
        const placeholder = mcEl.querySelector('.mc-img-placeholder');
        if (placeholder) {
          const isCustom = !machines.find(m => m.id === cropMachineId)?.sku;
          placeholder.outerHTML = `<div style="position:relative">
            <img class="mc-img" src="${publicUrl}" alt="">
            <label class="mc-img-upload" onclick="event.stopPropagation();document.getElementById('imgup-${cropMachineId}').click()">📷 Skift foto</label>
          </div>`;
        }
      }
    }
    // Opdater lokal cache
    const mc = machines.find(m => m.id === cropMachineId);
    if (mc) mc.custom_image_url = publicUrl;

    toast('✓ Billede gemt!');
  } catch (err) {
    toast('❌ Kunne ikke uploade billede');
    console.error(err);
  }
}

export async function addCustomMachine() {
  const brand  = document.getElementById('custBrand').value.trim();
  const model  = document.getElementById('custModel').value.trim();
  const serial = document.getElementById('custSerial').value.trim();
  const machType = document.getElementById('machTypeCust').value;
  if (!brand || !model) { toast('Udfyld mærke og model'); return; }
  const name = brand + ' ' + model;
  const { data, error } = await sb.from('machines').insert({
    name,
    user_id: sess.user.id,
    sku: null,
    custom_brand: brand,
    custom_model: model,
    custom_serial: serial || null,
    machine_type: machType
  }).select(MASKINE_FELTER).single();
  if (error) { toast('❌ ' + (error.message || 'Fejl')); return; }
  document.getElementById('custBrand').value = '';
  document.getElementById('custModel').value = '';
  document.getElementById('custSerial').value = '';
  toast('✓ ' + name + ' tilføjet!');
  loadMachines();
  if (machType !== 'standard') openBatModal(data.id);
}
